import { useEffect, useState } from 'react'
import {
    CCard,
    CCardBody,
    CCardHeader,
    CForm,
    CFormInput,
    CFormLabel,
    CFormSelect,
    CButton
} from '@coreui/react'
import Cookies from 'js-cookie'
import { COOKIE_ENUM } from '@webkit/enums/cookie.enum'
import UserService from '@services/user.service'
import { t } from 'i18next'
import { useSpinner } from '@webkit/components/typescript/SpinnerContext';
import { getToastStore } from '@utils/ToastStore';

const Settings = () => {
    const ctx = getToastStore(); 
    const { showSpinner, hideSpinner } = useSpinner();
    const [formData, setFormData] = useState({
        id: '',
        username: '',
        firstName: '',
        lastName: '',
        gender: '',
        phoneNumber: '',
    })
    const [successMessage, setSuccessMessage] = useState('')
    const [userData, setUserData] = useState()

    useEffect(() => {
        recoverProfileData()
    }, [userData])

    useEffect(() => {
        const cookieValue = Cookies.get(COOKIE_ENUM.HST_USER_PROFILE_DATA);
        if (cookieValue) {
            setUserData(cookieValue);
        }
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target
        setFormData({
            ...formData,
            [name]: value,
        })
    }

    const recoverProfileData = () => {
        if (!userData) return;
        const user = JSON.parse(userData);
        setFormData({
            id: user.id,
            username: user.username,
            firstName: user.person.name,
            lastName: user.person.surname,
            gender: user.person.gender,
            phoneNumber: user.person.mobileNumber
        });
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        try {
            showSpinner()
            const user = JSON.parse(userData)
            user.username = formData.username
            user.person.name = formData.firstName
            user.person.surname = formData.lastName
            user.person.gender = formData.gender
            user.person.mobileNumber = formData.phoneNumber
            user.id = formData.id

            const token = Cookies.get(COOKIE_ENUM.HST_USER_TOKEN)

            const response = await UserService.modifyPersonById(user.id, user.person)
            const msg =  response?.data?.message || t("success.changes_saved")
            ctx.setToastMsg(msg);
            ctx.setSeeToast(true);
            ctx.setErrorToast(false)
            Cookies.set(COOKIE_ENUM.HST_USER_PROFILE_DATA, JSON.stringify(user))
            setSuccessMessage(t("success.changes_saved"))
            setTimeout(() => setSuccessMessage(''), 3000)
        } catch (error) {
            console.error('errore nel Settings al salvataggio', error)
        }finally{
            hideSpinner()
        }
    }

    return (
        <div className="p-4">
            <CCard>
                <CCardHeader>
                    <h5>{t('title.profile_settings')}</h5>
                </CCardHeader>
                <CCardBody>
                    {successMessage && (
                        <div
                            style={{
                                backgroundColor: 'green',
                                color: 'white',
                                padding: '10px',
                                marginBottom: '15px',
                                borderRadius: '5px',
                            }}
                        >
                            {successMessage}
                        </div>
                    )}
                    <CForm onSubmit={handleSubmit}>

                        {/* Nome */}
                        <div className="mb-3">
                            <CFormLabel htmlFor="firstName">{t('label.first_name')}</CFormLabel>
                            <CFormInput
                                type="text"
                                id="firstName"
                                name="firstName"
                                value={formData.firstName}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        {/* Cognome */}
                        <div className="mb-3">
                            <CFormLabel htmlFor="lastName">{t('label.last_name')}</CFormLabel>
                            <CFormInput
                                type="text"
                                id="lastName"
                                name="lastName"
                                value={formData.lastName}
                                onChange={handleChange}
                                required
                            />
                        </div>

                        {/* Sesso */}
                        <div className="mb-3">
                            <CFormLabel htmlFor="gender">{t('label.select_gender')}</CFormLabel>
                            <CFormSelect
                                id="gender"
                                name="gender"
                                value={formData.gender}
                                onChange={handleChange}
                                required
                            >
                                <option value="">{t('label.select')}</option>
                                <option value="male">{t('label.male')}</option>
                                <option value="female">{t('label.female')}</option>
                                <option value="other">{t('label.other')}</option>
                            </CFormSelect>
                        </div>
                        {/* Numero di telefono */}
                        <div className="mb-3">
                            <CFormLabel htmlFor="phoneNumber">{t('label.phone_number')}</CFormLabel>
                            <CFormInput
                                type="text"
                                id="phoneNumber"
                                name="phoneNumber"
                                value={formData.phoneNumber}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
                            <CButton
                                className='text-uppercase'
                                type="submit"
                                style={{ backgroundColor: '#00BFA6', color: 'white', borderRadius: 25, fontWeight:"500" }}>
                                {t('button.save_changes')}
                            </CButton>
                        </div>
                    </CForm>
                </CCardBody>
            </CCard>
        </div>
    )
}

export default Settings
